import { B } from "../../design/tokens";
import IsabelChatbot from "../isabel/IsabelChatbot";

function saveContact() {
  const vcard = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "FN:Miraflor Rubio",
    "ORG:NESW Property & Planning Consultancy",
    "TITLE:Corporate Secretary",
    "TEL;TYPE=CELL:+639277196181",
    "EMAIL:miraflorrubio@neswcorp.com",
    "URL:https://www.neswcorp.com",
    "END:VCARD",
  ].join("\r\n");

  const blob = new Blob([vcard], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "miraflor-rubio.vcf";
  a.click();
  URL.revokeObjectURL(url);
}

const contacts = [
  {
    label: "Call me",
    value: "09277196181",
    href: "tel:+639277196181",
    bg: "#22C55E",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
      </svg>
    ),
  },
  {
    label: "Email me",
    value: "miraflorrubio@neswcorp.com",
    href: "mailto:miraflorrubio@neswcorp.com",
    bg: "#2563EB",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
      </svg>
    ),
  },
  {
    label: "Visit my website",
    value: "www.neswcorp.com",
    href: "https://www.neswcorp.com",
    bg: "#0B1D3A",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
    ),
  },
  {
    label: "Visit my office",
    value: "Quezon City",
    href: "https://maps.google.com/?q=Quezon+City+Philippines",
    bg: "#EA4335",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    ),
  },
  {
    label: "Follow me",
    value: "@neswrealty",
    href: "https://facebook.com/neswrealty",
    bg: "#1877F2",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
      </svg>
    ),
  },
];

function Photo() {
  return (
    <img
      src="/miraflorrubio.jpg"
      alt="Miraflor Rubio"
      style={{
        width: 120,
        height: 120,
        borderRadius: "50%",
        objectFit: "cover",
        objectPosition: "center 10%",
        border: "3px solid rgba(255,255,255,0.25)",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
      }}
    />
  );
}

export default function MiraflorrubioCard() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Inter:wght@300;400;500;600&display=swap');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Inter', sans-serif; -webkit-font-smoothing: antialiased; }
        @keyframes isabel-pulse {
          0%   { transform: scale(1);    opacity: 0.8; }
          70%  { transform: scale(1.55); opacity: 0;   }
          100% { transform: scale(1.55); opacity: 0;   }
        }
        @keyframes isabel-slide-in {
          from { opacity: 0; transform: translateY(18px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes isabel-dot {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
          40%            { transform: scale(1);   opacity: 1;   }
        }
      `}</style>

      <div style={{
        minHeight: "100vh",
        background: "#f1f5f9",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "24px 16px 48px",
        fontFamily: "'Inter', sans-serif",
      }}>
        <div style={{
          background: B.white,
          borderRadius: 24,
          width: "100%",
          maxWidth: 400,
          overflow: "hidden",
          boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
        }}>
          {/* Header */}
          <div style={{
            background: `linear-gradient(160deg, ${B.navy} 0%, #1e3a5f 100%)`,
            padding: "40px 24px 28px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 14,
          }}>
            <Photo />
            <div style={{ textAlign: "center" }}>
              <div style={{
                fontSize: 28,
                fontWeight: 700,
                fontFamily: "'Playfair Display', serif",
                color: B.white,
                letterSpacing: "0.2px",
                lineHeight: 1.2,
              }}>
                Miraflor Rubio
              </div>
              <div style={{
                fontSize: 15,
                color: "rgba(255,255,255,0.90)",
                marginTop: 5,
                fontWeight: 500,
              }}>
                Corporate Secretary
              </div>
              <div style={{
                fontSize: 13,
                color: "rgba(255,255,255,0.62)",
                marginTop: 3,
                fontWeight: 400,
              }}>
                NESW Property & Planning Consultancy
              </div>
            </div>
          </div>

          {/* Save Contact */}
          <div style={{ padding: "20px 20px 8px" }}>
            <button
              onClick={saveContact}
              style={{
                width: "100%",
                padding: "15px 0",
                background: B.ink,
                color: B.white,
                border: "none",
                borderRadius: 12,
                fontSize: 16,
                fontWeight: 600,
                fontFamily: "'Inter', sans-serif",
                cursor: "pointer",
                letterSpacing: "0.2px",
              }}
            >
              Save Contact
            </button>
          </div>

          {/* Contact rows */}
          <div style={{ padding: "8px 20px 24px", display: "flex", flexDirection: "column", gap: 10 }}>
            {contacts.map(({ label, value, href, bg, icon }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "12px 14px",
                  background: "#f8fafc",
                  borderRadius: 12,
                  textDecoration: "none",
                  border: "1px solid #e2e8f0",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#f1f5f9"}
                onMouseLeave={e => e.currentTarget.style.background = "#f8fafc"}
              >
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}>
                  {icon}
                </div>
                <div>
                  <div style={{ fontSize: 12, color: B.slate, fontWeight: 500, marginBottom: 2 }}>{label}</div>
                  <div style={{ fontSize: 14, color: B.ink, fontWeight: 600 }}>{value}</div>
                </div>
              </a>
            ))}
          </div>

          {/* Isabel Chatbot */}
          <IsabelChatbot />

          {/* Footer */}
          <div style={{
            borderTop: "1px solid #f1f5f9",
            padding: "12px 20px",
            textAlign: "center",
            fontSize: 12,
            color: "#94a3b8",
          }}>
            neswcorp.com
          </div>
        </div>
      </div>
    </>
  );
}
